import * as React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import "swiper/css";
import "swiper/css/pagination";
import { Pagination, } from "swiper";

import './MyCollections.scss';
import { myCollections } from '../../Shared/MyWatchListAndCollectionsData';
import { NavLink } from 'react-router-dom';
import { PostGrid } from '../../Components/PostGrid/PostGrid';
import { PreviewCarousel } from '../../Components/PreviewCarousel/PreviewCarousel';
import { useEffect } from 'react';
export interface IMyCollectionsProps {
}

export function MyCollections(props: IMyCollectionsProps) {
    const [featuredCollectionData, setFeaturedCollectionData] = React.useState(myCollections)


    const [windowWidth, setWindowWidth] = React.useState(1920)

    useEffect(() => {
        setWindowWidth(window.outerWidth);
    })

    const [carouselDataWithOpen, setCarouselDataWithOpen] = React.useState({
        isOpen: false,
        image: null,
        rootData: null,
    })

    const getImageData = (clickedImageSource?: any, clickedRootData?: any) => {
        setCarouselDataWithOpen({
            isOpen: true,
            image: clickedImageSource,
            rootData: clickedRootData,
        })
    }

    const getPostGridPorps = (images: any, rootData: any) => {
        let heightNumber = [140, 140]
        if (images.length >= 5) {
            heightNumber = windowWidth > 640 ? [140, 140] : [100, 100]
        }
        else if (images.length === 1) {
            heightNumber = windowWidth > 640 ? [292] : [214]
        }
        else if (images.length === 2) {
            heightNumber = windowWidth > 640 ? [292] : [214]
        }
        else if (images.length === 3) {
            heightNumber = windowWidth > 640 ? [140, 140] : [100, 105]
        }
        else if (images.length === 4) {
            heightNumber = windowWidth > 640 ? [140, 140] : [100, 100]
        }

        return {
            itemsLength: images.length,
            getDataByOnClick: getImageData,
            rootData: rootData,
            gapX: 12,
            gapY: 12,
            radius: 10,
            heights: heightNumber,
            images: images,
        };
    }


    const handleFeaturColleLoveClick = (id: number) => {
        const prevCollectionData = [...featuredCollectionData]
        const findClickedData = prevCollectionData.find(data => data.id === id);

        if (findClickedData?.isMyLoved) {
            findClickedData.loves = findClickedData.loves - 1;
            findClickedData!.isMyLoved = false;
            setFeaturedCollectionData(prevCollectionData)
        } else {
            findClickedData!.loves = findClickedData!.loves + 1;
            findClickedData!.isMyLoved = true;
            setFeaturedCollectionData(prevCollectionData)
        }
    }





    return (
        <div className="relative overflow-hidden">
            <div className="
        pt-[64px]
        sm:max-w-[570px] sm:pt-[80px]
        md:max-w-[660px]
        lg:max-w-[870px]
        xl:max-w-[1100px]
        2xl:max-w-[1336px]
        3xl:max-w-[1436px]
        mx-auto xs:mt-6 sm:mt-10 md:mt-24 pb-28 md:pb-24 px-4 my_collections_main_box">

                {carouselDataWithOpen.isOpen &&
                    <PreviewCarousel
                        setCarouselDataWithOpen={setCarouselDataWithOpen}
                        image={carouselDataWithOpen.image}
                        rootData={carouselDataWithOpen.rootData} />
                }


                <div className="flex justify-between items-start sm:items-center">
                    <div className="text-left">
                        <h1 className="text-xl sm:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white">My Collections</h1>
                        <p className="xs:text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2 w-10/12 lg:w-full">Create, curate, and manage collections of unique NFTs to share and sell</p>
                    </div>

                    <NavLink to="/createCollection" className="px-2 sm:px-4 py-2 gradientBtn sm:py-3.5 rounded-md text-white flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={21} height={21} viewBox="0 0 21 21">
                            <defs>
                                <clipPath id="clip-path">
                                    <rect id="Rectangle_1362" data-name="Rectangle 1362" width={21} height={21} transform="translate(0)" fill="#fff" />
                                </clipPath>
                            </defs>
                            <g id="Group_1492" data-name="Group 1492" transform="translate(0)" clipPath="url(#clip-path)">
                                <path id="Path_996" data-name="Path 996" d="M101.567,85.34H99.658v1.909h.954v13.364H87.249v-.954H85.34v1.909a.954.954,0,0,0,.954.955h15.273a.954.954,0,0,0,.955-.955V86.294a.954.954,0,0,0-.955-.954Z" transform="translate(-81.021 -82.021)" fill="#fff" />
                                <path id="Path_997" data-name="Path 997" d="M16.228,0H.955A.954.954,0,0,0,0,.955V16.228a.954.954,0,0,0,.955.954H16.228a.954.954,0,0,0,.954-.954V.955A.954.954,0,0,0,16.228,0ZM12.819,9.546H9.546v3.273H7.637V9.546H4.363V7.637H7.637V4.363H9.546V7.637h3.273Z" transform="translate(0.5 -0.5)" fill="#fff" />
                            </g>
                        </svg>

                        <p className="ml-3 text-xs sm:text-base">Create a collection</p>
                    </NavLink>
                </div>



                {/* ----------------------------Popular Collections---------------------------- */}
                <div className="mt-6 swiper_pagination_controller_box relative pt-3">

                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            0: { slidesPerView: 1, spaceBetween: 40, },
                            769: { slidesPerView: 2, spaceBetween: 15, },
                            1024: { slidesPerView: 2, spaceBetween: 15, },
                            1280: { slidesPerView: 3, spaceBetween: 15, },
                            1536: { slidesPerView: 3, spaceBetween: 15, },
                        }}
                        effect="fade"
                        modules={[Pagination]}
                        className="mt-3 overflow-visible"
                    >
                        {featuredCollectionData.map((collection, index) =>
                            <SwiperSlide key={collection.id}>
                                <div className="xs:p-3 sm:p-5 mt-5 rounded-xl lightBlueBg">
                                    <div className="myCollections_photo_grid_box">
                                        <PostGrid propObject={getPostGridPorps(collection.thumbs, collection.thumbs)} />
                                    </div>

                                    <div className="flex justify-between items-center xs:mt-4 md:mt-6 2xl:mt-4">
                                        <div className="flex justify-start items-center">
                                            <div className="xs:h-10 xs:w-10 sm:h-16 sm:w-16 md:w-10 md:h-8 lg:h-10 2xl:h-16 2xl:w-16 rounded-full relative ">
                                                <img src={collection.profilePhoto} alt="" className="w-full h-full" />
                                                <div className="absolute -bottom-2 -right-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-7 sm:w-8 md:w-6 lg:w-7 2xl:w-auto" xmlnsXlink="http://www.w3.org/1999/xlink" width="34.249" height="35.201" viewBox="0 0 34.249 35.201">
                                                        <defs>
                                                            <filter id="Path_737" x={0} y={0} width="34.249" height="35.201" filterUnits="userSpaceOnUse">
                                                                <feGaussianBlur stdDeviation={3} result="blur" />
                                                                <feFlood floodColor="#f08" floodOpacity="0.314" />
                                                                <feComposite operator="in" in2="blur" />
                                                                <feComposite in="SourceGraphic" />
                                                            </filter>
                                                        </defs>
                                                        <g id="Group_1298" data-name="Group 1298" transform="translate(-1880.164 -1579.313)">
                                                            <g transform="matrix(1, 0, 0, 1, 1880.16, 1579.31)" filter="url(#Path_737)">
                                                                <path id="Path_737-2" data-name="Path 737" d="M631.683,279.559s7.027-1.882,13.6,0a35.8,35.8,0,0,1-.061,14.375,29.879,29.879,0,0,1-13.568.032S629.949,286.243,631.683,279.559Z" transform="translate(-621.31 -272.12)" fill="#ff0091" stroke="#e90185" strokeMiterlimit={10} strokeWidth={1} />
                                                            </g>
                                                            <image id="Image_44" data-name="Image 44" width="10.02" height="10.02" transform="translate(1892.224 1588.373)" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAACChJREFUeAHt3T2LJEUYB3BnUeTkblF8QVRcOQNBg0sO5ORUxEv0CxiIiWhkJGrgFxCDEwzMNNFEDE0ORJaFvdUzMDERDBROVAQDQUQTmfF5lnn2amqqq6u76+2p/i803V3dU1X9rx81vbN9N4vVanUTfpBA7AR2YleI+pAAJwBYcJAkAcBKEisqBSwYSJIAYCWJFZUCFgwkSQCwksSKSgELBpIkAFhJYkWlgAUDSRIArCSxolLAgoEkCQBWklhRKWDBgCuB81T4outAaNnNoSfivNkkcI4epdqnqz2zWCz+o/VnY64cM9aY1Np9zXlCdUjLLi0LWj6lS31hzOUC1pjU2nwNozqgZVcuj7YF10tSFroGrNCk2j5PUJ22L3ON62MqH4QLsOwk57ffiUqiGIMLsCS9ea57UUksBq5XpMy35vdQ33EcazeBYFR2BDs7O69S2Ud2ubmPGctMYz7bo1FxRMvl8kNaeWcuwJoPJrnSSaikkj5cgCVJzWMdBZVEtcb1muyba8Ay02h7OyoqiYpwfUDbW7gASxJqe50ElUTmwgVYkk6766SoJLY1rjdkH7AkiTbXWVBJdITrMm0f48LnWJJKe+usqMz46HOuNzFjmYm0s10MFUdIM9cZzFjtYJIrKYqKOvEuzVhvY8aS4WhjXQUqjhKw2gDFV1ENKu4MYHEK+n+qQsVxAhZQTU3g+J7KrgSw7ER07V+gx54OaNl68jPTZThRcdv4VzqZRiBBM4xqn5ZTCeoOqbITFb8YM1ZIhPWdUzUqwKoPTEiPqkcFWCHDWNc5KlABVl1o+nqjBhVg9Q1lPcdVoQKseuD4eqIOFWD5hrOOYypRAVYdeLp6oRYVYHUNafly1agAqzwgVw/UowIs17CWLWsCFWCVRWS33gwqwLKHttx+U6gAqxwks+XmUAGWObxltptEBVhlMEmrzaICLBni/OumUQFWflDcYvOoACs/rKdrfpw4Zhx45j1mmv66GNUXtNzqPy3ZUe8z6rFbxTPvsRN11zcrVBwBYLkhxCydHSrAisnHXdcsUQGWG0Os0tmiAqxYhLbrmTUqwNoGEaNk9qgAKwajzTqAap0HfivchDFlD6iM9ADLCGPCJlBZ4QGWFciIXaByhAZYjlAGFAFVR1iA1RFMQDFQeUICLE84nkNA5QmHDwFWT0COw0DlCMUuAiw7Ef8+UPnzOTkKWCdR9G4AVW9EN04ArBtZ+LaAypeO4xhgOUKxioDKCiRkdwqsu1ar1VVq5LGQhpSec4mucTaPE8cco7Hf/nUnBf4VLY8sFos/ablInfo+ZscqqItRXaHllkJ9yfqMeuxrHDNjnaDizlDwd9ByRJuPxu5cwfqAamL4Q2FtoJK2G8MFVDKwE9ZDYN1DgI7f/lztNYILqFyDO6Is9B6LUV2j5WxfG4rvuYCqb3AHHA+BFYxK2lWIqzSq9+nrbl+X/FpY970VDkbFoRhvi+cUhARUCQbJN2ONQmX2kWauv2h5isq+M8sr2gaqRIPRNWPdF3pP5esX1bFLyyGdU+PMBVS+wZt4zDVjMaqvadmbWPfJyyucuYDqZHTSbNgzVnRU3O3KZi6gSmNpo1YTVhJU0loluIBKBiTxWmA9GPvtz9XvwriAyjUoicr4HktQ3Z+oja1qC9xzAdXWKKQt2CFYn9CSDRVfznrm4kduHk97ece1P7dcLr+kNks9pfBeax9+howZz1h7tBzR8kDIC2KeQzPX37Q8Q3V+G7Neoy7MVEYYOTf5Hus6De5FWn7J2TC3RZhP03JAm+cTtA1UCUINrVJu3lvDBVShAhKdJ7C4+lZwAVUiLEOqNWG1gAuohox+wnNtWJpxPU/3a1doKfXbX3OPvkxx54KlERej+hyoplCI+9ouWLXguhBwuYKq1LdsYKZyDJLr6Qb7tD2aCY5oKfE517/0Mciz1KFrdqfW+0DVEUzpYt+MJX0r+dviKQK9Tx1xzVxAJSNU4ToEFne7NlxAVSEms0shb4Xm+Q/RDHK14NviJerM7dQ+36jjnsocmcq2h8Li7p+lQT2kJesfrrlhut/6h9q9jbcL/VymPyi/VahtVc2OgcUXuEcDXOSGvmC6+O1vQPhjYQmubwjYvQPa03oqUA0cudCbd1e1ckP/u+tgQ2VANWIwp8Di5n6k+x5+5KZVXEA1AhW/ZCosrqNVXEDFozvyJwYsbro1XEA1EpS8LBaslnABleiYsI4JqwVcQDUBk/nS2LA04wIqU8bE7RSwNOICqomQ7JengqUJF1DZKiLsp4SlARdQRUDkqiI1rJpxAZVLRKSyHLBqxAVUkQB1VZMLVk24gKpLQ8TynLBqwAVUEfH4qpry2Iyv3r5jD9PjNvz/xt/dd2LE40AVMcy+qnLPWNIf/tvik7T8IQWJ10CVOGC7+lKwuB8/ZMIFVPaoZ9gvCSsHLqDKgMjVRGlYKXEBlWvEM5XVACsFLqDKBKirmVpgxcQFVF2jnbG8JlgxcAFVRjy+pkp9juXrEx8b81+EA1VfqhmP1zZjyaX/TB9FPEHLr1LQswaqnoByH64VFucguK73hAJUPQGVOFzrW6GZhe87foDKTKqi7ZpnLInpt/Xb4k9SsF4DlRVITbsaZizJy/zGV6CSVCpda4LFEfJ/QPIyLe/wDn7qTUAbrHqTRM82EtBwj7XRYezoSACwdIyTul4Clroh09FhwNIxTup6CVjqhkxHhwFLxzip6yVgqRsyHR0GLB3jpK6XgKVuyHR0GLB0jJO6XgKWuiHT0WHA0jFO6noJWOqGTEeH/wdzkuX79XH1igAAAABJRU5ErkJggg==" />
                                                        </g>
                                                    </svg>
                                                </div>
                                            </div>

                                            <div className="ml-4 text-left">
                                                <h4 className="xs:text-sm sm:text-xl md:text-xs lg:text-sm xl:text-xs 2xl:text-xl font-semibold text-cusBlack dark:text-white">{collection.profileName}</h4>
                                                <p className="text-cusBlack dark:text-cusGray xs:text-xs sm:text-sm xl:text-xs 2xl:text-sm mt-1">Created by
                                                    <span className="text-black dark:text-white dark:font-normal font-extrabold xs:text-xs ml-1 sm:text-sm md:text-xs 2xl:text-sm">{collection.owner}</span></p>
                                            </div>
                                        </div>

                                        <button
                                            onClick={() => handleFeaturColleLoveClick(collection.id)}
                                            className="collections_slide_loves dark:bg-cusBlack bg-gray-200 flex justify-between xs:px-2 sm:px-4 xs:py-1 sm:py-2 items-center rounded-full">
                                            <p className="text-cusBlack dark:text-cusBlueWhite text-xs mr-2">{collection.loves}</p>

                                            {collection.isMyLoved
                                                ? <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="#ff0091" stroke="#ff0091">
                                                    <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" strokeWidth={2} />
                                                </svg>
                                                : <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="#ff0091">
                                                    <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" strokeWidth={2} />
                                                </svg>
                                            }

                                        </button>
                                    </div>

                                </div>
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>













            </div>
        </div>
    );
}
